import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './OrderDetailPage.css';
import CakePaymentsPage from './CakePaymentsPage';
import { FaRegMoneyBillAlt } from 'react-icons/fa';
import { MdOutlineAssignment } from 'react-icons/md';

export default function OrderDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [tab, setTab] = useState(0); // 0: Order Details, 1: Cake Payments
  const [payments, setPayments] = useState([]);

  useEffect(() => {
    async function fetchOrder() {
      try {
        setLoading(true);
        const res = await fetch(`https://devbite.vercel.app/api/order_detail?id=${id}`);
        if (!res.ok) throw new Error('Failed to fetch order details');
        const data = await res.json();
        setOrder(data.order);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }
    async function fetchPayments() {
      try {
        const res = await fetch(`https://devbite.vercel.app/api/order_payments?orderid=${id}`);
        if (!res.ok) throw new Error('Failed to fetch payments');
        const data = await res.json();
        setPayments(data.payments || []);
      } catch (e) {
        setPayments([]);
      }
    }
    fetchOrder();
    fetchPayments();
  }, [id]);

  function formatAmount(amount) {
    return Number(amount || 0).toLocaleString('en-US');
  }

  if (loading) return <div className="order-detail-loading"><div className="spinner"></div></div>;
  if (error) return <div className="order-detail-error">{error}</div>;
  if (!order) return <div className="order-detail-empty">Order not found.</div>;

  const {
    cakeWritings = '',
    cakePrice = '',
    cakeColor = '',
    flavors = [],
    icing = '',
    pickDate = '',
    pickTime = '',
    deliveryPlace = '',
    customer = '',
    customerNumber = '',
    description = '',
    createdByName = '',
    createdByPhoto = '',
    images = [],
    verified = false,
    createdAt = null,
    id: orderId = '',
  } = order;

  return (
    <div className="order-detail-bg">
      <header className="order-detail-header">
        <button className="order-detail-back" onClick={() => navigate(-1)}>&larr;</button>
        <h2 className="order-detail-title">Order Detail</h2>
      </header>
      <div className="order-detail-content">
        {tab === 0 ? (
          <div className="order-detail-card">
            <div className="order-detail-top">
              <div className="order-detail-img-wrap">
                {images.length > 0 ? (
                  <img src={images[0]} alt="Order" className="order-detail-img" />
                ) : (
                  <div className="order-detail-img-placeholder">No Image</div>
                )}
              </div>
              <div className="order-detail-summary">
                <div className="order-detail-writings">{cakeWritings}</div>
                <div className="order-detail-price">UGX {formatAmount(cakePrice)}</div>
                <div className="order-detail-color">Color: {cakeColor}</div>
              </div>
              <div className="order-detail-avatar-wrap">
                {createdByPhoto ? (
                  <img src={createdByPhoto} alt="User" className="order-detail-avatar" />
                ) : (
                  <div className="order-detail-avatar-placeholder">👤</div>
                )}
              </div>
            </div>
            <div className="order-detail-section">
              <div className="order-detail-label">Deposit</div>
              <div className="order-detail-value">
                UGX {formatAmount(payments.filter(p => p.status === 'success').reduce((sum, p) => sum + Number(p.amount || 0), 0))}
              </div>
            </div>
            <div className="order-detail-section">
              <div className="order-detail-label">Customer</div>
              <div className="order-detail-value">{customer} ({customerNumber})</div>
            </div>
            <div className="order-detail-section">
              <div className="order-detail-label">Delivery Place</div>
              <div className="order-detail-value">{deliveryPlace}</div>
            </div>
            <div className="order-detail-section">
              <div className="order-detail-label">Flavors</div>
              <div className="order-detail-value">{Array.isArray(flavors) ? flavors.join(', ') : flavors}</div>
            </div>
            <div className="order-detail-section">
              <div className="order-detail-label">Icing</div>
              <div className="order-detail-value">{icing}</div>
            </div>
            <div className="order-detail-section">
              <div className="order-detail-label">Pick Date</div>
              <div className="order-detail-value">{pickDate}</div>
            </div>
            <div className="order-detail-section">
              <div className="order-detail-label">Pick Time</div>
              <div className="order-detail-value">{pickTime}</div>
            </div>
            <div className="order-detail-section">
              <div className="order-detail-label">Description</div>
              <div className="order-detail-value">{description}</div>
            </div>
          </div>
        ) : (
          <CakePaymentsPage order={order} />
        )}
      </div>
      <div className="order-detail-bottom-tabs">
        <button className={tab === 0 ? 'order-detail-bottom-tab order-detail-bottom-tab-active' : 'order-detail-bottom-tab'} onClick={() => setTab(0)}>
          <MdOutlineAssignment className="order-detail-bottom-tab-icon" />
          <span>Order Details</span>
        </button>
        <button className={tab === 1 ? 'order-detail-bottom-tab order-detail-bottom-tab-active' : 'order-detail-bottom-tab'} onClick={() => setTab(1)}>
          <FaRegMoneyBillAlt className="order-detail-bottom-tab-icon" />
          <span>Cake Payments</span>
        </button>
      </div>
    </div>
  );
}
